import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BOOK_CTA, BOOK_PHOTOS, FEATURED_BOOK } from "@/lib/books";

export const HomeBookTeaser = () => (
  <section className="py-24 overflow-hidden" style={{ backgroundColor: "#FBF8F1" }} data-testid="home-book-teaser">
    <div className="max-w-[1300px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <p className="overline mb-4 flex items-center gap-2" style={{ color: "var(--gold)" }}><Sparkles size={14} /> New · Personalized Swim Books</p>
        <h2 className="font-display text-4xl md:text-5xl leading-tight" style={{ color: "var(--navy)" }}>
          {FEATURED_BOOK.title}<span className="block italic text-3xl md:text-4xl mt-2" style={{ color: "#2BA8A0" }}>starring your little swimmer.</span>
        </h2>
        <p className="font-body font-light text-lg mt-6 leading-relaxed max-w-lg" style={{ color: "var(--muted)" }}>
          One heartwarming swimming story, personalized with your child's name and illustrated likeness alongside Coach Mimi — a hardcover keepsake that keeps confidence growing between lessons.
        </p>
        <Link to="/swim-books" className="btn-primary mt-8" data-testid="home-book-cta">{BOOK_CTA}</Link>
      </Reveal>
      <Reveal delay={0.12}>
        <motion.img
          src={BOOK_PHOTOS[0].src} alt={`${FEATURED_BOOK.title} hardcover book`}
          whileHover={{ rotate: -1.5, scale: 1.02 }} transition={{ type: "spring", stiffness: 200, damping: 18 }}
          className="w-full max-w-[440px] mx-auto rounded-3xl"
          style={{ boxShadow: "0 30px 60px rgba(11,27,61,0.22)" }}
          data-testid="home-book-cover"
        />
      </Reveal>
    </div>
  </section>
);
